/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon32Regular = forwardRef('ArrowADownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M15 26.74V4a1 1 0 1 1 2 0v22.74c.148-.086.288-.192.414-.318l8.379-8.38a1 1 0 0 1 1.414 1.415l-8.379 8.379a4 4 0 0 1-5.656 0l-8.38-8.379a1 1 0 1 1 1.415-1.414l8.379 8.379c.127.126.266.232.414.318Z" })));
});
